//強みmodal
$(function () {
  $('#openModal').click(function(){
      $('#modalArea').fadeIn();
  });
  $('#closeModal , #modalBg').click(function(){
    $('#modalArea').fadeOut();
  });
});

//外部リンク
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
if (links[i].hostname !== window.location.hostname) {
links[i].target = '_blank';
links[i].rel = 'noreferrer noopener';
}
}
//スムーススクロール
jQuery(function(){
    var windowWidth = $(window).width();
    var headerHight = 90; 
    jQuery('a[href^="#"]').click(function() {
    var speed = 500;
    var href= jQuery(this).attr("href");
    var target = jQuery(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top-headerHight;
    jQuery('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
   });
});

//右メニュー開閉
jQuery(function($){
    $('.open-close').on('click',function(){
        $('.header--right-column').toggleClass('active');
    });
});

//商品紹介スワイパー
const swiper = new Swiper(".mySwiper", {
  spaceBetween: 10,
  slidesPerView: 6
});

const swiper2 = new Swiper(".mySwiper2", {
  loop: true,
  thumbs: {
    swiper: swiper
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});

//TOPスライダー
//Slider1
var slider1 = new Swiper ('.slider-content01', {
		//loop: true,
		//loopAdditionalSlides: 2,
  slidesPerView: 1.1,
		spaceBetween:20,
		//autoplay: {
  //  	delay: 4000,
		//},
		centeredSlides : false,
  	navigation: { 
    	nextEl: '.swiper-button-next01', //「次へボタン」要素の指定
    	prevEl: '.swiper-button-prev01', //「前へボタン」要素の指定
  	},
		breakpoints: {
        800: {
						centeredSlides: false,
						spaceBetween: 20,
            slidesPerView: 2.8,
						//loop: false,
						loopAdditionalSlides: 0,
        }
    },
});

//商品紹介number
$('.btn-minus').on('click', function(e) {
  var input = $(e.target).closest('.form-type-number').find('input');
  input[0]['stepDown']();
});
$('.btn-plus').on('click', function(e) {
  var input = $(e.target).closest('.form-type-number').find('input');
  input[0]['stepUp']();
});

// ページ最下部までスクロールしたかを判定するための位置を計算
const html = document.querySelector('html');
const bodyHeight = document.body.clientHeight;
const windowHeight = window.innerHeight;
const bottomPoint = bodyHeight - windowHeight;
html.classList.add('is-scrolling');
window.addEventListener('scroll', () => {
  const currentPos = window.pageYOffset // スクロール量を取得
  if (bottomPoint <= currentPos) { // スクロール量が最下部の位置を過ぎたかどうか
    html.classList.remove('is-scrolling');
    html.classList.add('is-scrollEnd');
  } else {
    html.classList.remove('is-scrollEnd');
    html.classList.add('is-scrolling');
  }
});


// @FIX: Here is fix off canvas left menu not hide when first click search button
// Here we watch for new elements
const observer = new MutationObserver(function () {
  if($('.modal--content') && $('.modal--content').hasClass('active') 
    && $('.modal--content.active').find('.search--root').length
    && ('.off-canvas--left-sidebar[data-transition="at_end"]').length > 0) {
    $('off-canvas-root transition-root[aria-label="close"]').trigger('click')
  }
});

// Param 1 of observe() must be a Node - document is a valid Node, 
// but not advisable, limit the watcher to as small a context as possible
// Important here to set attributes to be true to check these. 
observer.observe(document.getElementsByClassName('modal--window')[0], {
 attributes: true
});

$(function(){
  const clssProductFav = '.favhero-products';

  setTimeout(renderedFavProducts, 0);
  appendCssResetFavPage();

  
  function renderedFavProducts() {
    if (!$(clssProductFav).length) {
      window.requestAnimationFrame(renderedFavProducts);
    } else {
      
      let btnAddCartFavProducts = $(clssProductFav + ' .favhero-product__add-to-card-button');
      $(btnAddCartFavProducts).addClass('btn-yellow-w').css({"display": "none"}).remove();
    }
  };
  
  function appendCssResetFavPage() {
  	let pathname = window.location.pathname;
    if(/^\/apps\/favhero/.test(pathname)) {
      let cssHead = "<style>img, svg, video, canvas, audio, iframe, embed, object {display: initial;}</style>";
      let scriptHead = '<script type="module">import "//cdn.shopify.com/s/files/1/0639/3803/5948/t/4/assets/featured-collection.js?v=1585368473911885231651529787";</script>';
      $('head').append(cssHead);
      $('head').append(scriptHead);
    }
  }
  	
})